import { useHideElement } from '../hooks/use-hide-element.js';

const quizSubmittedAction = async (results, quizId, courseId) => {
    const formData = new FormData();

    localStorage.removeItem(`LP_Quiz_${quizId}_Rozetka`);

    useHideElement({
        selector: '.lp-button.start',
        condition: () => window.LP_QUIZ_SETTINGS?.red_hide_retake && results?.pass,
    });

    formData.append('action', 'red_lp_next_course_item')
    formData.append('course_id', courseId)
    formData.append('item_id', quizId)

    const response = await fetch(rozetka_learnpress_global.ajax.url, {
        method: 'POST',
        credentials: 'same-origin',
        body: formData
    })

    const {success, data} = await response.json()

    if (success) {
        const { next_item_url } = data

        if (next_item_url.length > 0) {
            function insertTimerWhenReady() {
                const quizResultElement = document.querySelector('.quiz-result.passed');

                if (quizResultElement) {
                    const parentDiv = quizResultElement.parentElement

                    const { timerContainer, timerValueElement } = createTimer()

                    parentDiv.insertBefore(timerContainer, parentDiv.firstChild)

                    let timeLeft = 10
                    const intervalId = setInterval(() => {
                        timeLeft -= 1
                        timerValueElement.textContent = timeLeft

                        if (timeLeft <= 0) {
                            clearInterval(intervalId)
                            window.location.replace(next_item_url)
                        }
                    }, 1000)

                    observer.disconnect()
                }
            }

            const observer = new MutationObserver(() => {
                insertTimerWhenReady()
            })

            observer.observe(document.body, { childList: true, subtree: true });
        }
    }
}

const createTimer = () => {
    const timerContainer = document.createElement('div')
    timerContainer.className = 'timer-container'

    const textElement = document.createElement('span')
    textElement.className = 'timer-text'
    textElement.textContent = rozetka_learnpress_global.localText.timerText

    const timerValueElement = document.createElement('span')
    timerValueElement.className = 'timer-value'
    timerValueElement.textContent = '10'

    timerContainer.appendChild(textElement)
    timerContainer.appendChild(timerValueElement)

    return { timerContainer, timerValueElement }
}

export default quizSubmittedAction